import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";

import { ChemistrySample } from "@/pages/caster/models/ElementData";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { useElementTableData } from "./hooks/useElementTableData";
import { useElementStyles } from "./styles/useElementStyles";

interface Props {
	elementList: ChemistrySample[];
	coloringEnabled: boolean;
	onToggleColoring: (enabled: boolean) => void;
}

export const ElementTable = ({
	elementList,
	coloringEnabled,
	onToggleColoring,
}: Props) => {
	const commonTableClasses = useTableStyles();
	const localClasses = useElementStyles();

	const { columns, rowData, getRowStyle, frameworkComponents, statusBar } =
		useElementTableData({
			elementList,
			coloringEnabled,
			onToggleColoring,
		});

	const gridHeight = 65 + rowData.length * 35 + 2;
	const minHeight = 200;

	return (
		<>
			<Paper
				className={commonTableClasses.borderAgGridTable}
				elevation={0}
				style={{ margin: "10px 0px" }}
			>
				<Box p={0}>
					<div
						className={localClasses.gridWrapper}
						style={{
							height: `${Math.max(gridHeight, minHeight)}px`,
							minWidth: "100%",
						}}
					>
						<AgGridReact
							rowData={rowData}
							columnDefs={columns}
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							suppressContextMenu
							getRowId={(params) => params.data.id}
							getRowStyle={getRowStyle}
							noRowsOverlayComponent={() => "No chemistry data available"}
							components={frameworkComponents}
							statusBar={statusBar}
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
